import { HStack, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

import { InfoIcon } from "..";

export const InfoText = ({ children }: { children: ReactNode }): React.ReactElement => (
  <HStack alignItems="start" color="gray.500" mt="2">
    <InfoIcon size="1.3rem" />
    <Text fontSize="sm">{children}</Text>
  </HStack>
);
